import { statisticsConstants} from '../_constants';
import {StatiticsService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const StatisticsActions = {
  insertarTramiteStatistics,  
};
function insertarTramiteStatistics(tramite) {
    return dispatch => {
        dispatch(request());
        StatiticsService.insertStatistics(tramite)
            .then(          
                tramite => dispatch(success(tramite)),                
                error => dispatch(failure("Contraseña actual Incorrecta"))
            );
    };
    function request() { return { type: statisticsConstants.STATISTICS_REQUEST } }
    function success(tramite) { return { type: statisticsConstants.STATISTICS_SUCCESS, tramite } }
    function failure(error) { return { type: statisticsConstants.STATISTICS_FAILURE, error } }
}